var GROUP_PRIVATE = 'PRIVATE';
var GROUP_PUBLIC = 'PUBLIC';
var GROUP_SECRET = 'SECRET';

module.exports = {
  GROUP_PRIVATE,
  GROUP_PUBLIC,
  GROUP_SECRET
}
